import * as React from 'react';
import InvoiceFilters from '../InvoiceFilters';
import EnhancedTable from 'src/components/TableInvoices';
import DateRange from 'src/components/common/DateRange';
import DateRangeModel from 'src/model/dateRange.model';
import { statusType, sortType } from 'src/model/modules/invoices.model';
import {
  IFiltersInvoice,
  IPaginationInvoice
} from 'src/services/invoice/InvoiceService';
import MultipleSelect from '../Filter/AllInvoices';
import MultipleSelectStatus from '../Filter/AllStatus';
import './OpenInvoices.scss';
import settings from '../../../../assets/settings';
import PrintIcon from '../../../../assets/print';
import exportIcon from '../../../../assets/export';
import DownArrowIcon from '../../../../assets/downArrowIcon';
import RightArrow from '../../../../assets/rightArrow';
import ApplyToOriginal from '../ApplyToOriginal';
import { Redirect, withRouter, RouteComponentProps } from 'react-router-dom';
import MatrialCloseIcon from '@material-ui/icons/Close';
import InvoiceRoute from '../InvoiceRoute/InvoiceRoute';
import ApplyToOldest from '../ApplyToOldest';
import Modal from 'src/components/common/Modal';
import CloseIcon from '../../../../assets/images/close.svg';
import CustomPaginator from 'src/components/common/CustomPaginator';
import SelectCreditTable from 'src/components/TablesAllInvoices/SelectCredit/SelectCredit';
import DataTable from 'src/components/TableInvoices/TableInvoice';
import ApplyCreditOriginal from '../ApplyCredit/ApplyCreditOriginal';
import { currencyFormatter } from 'src/utils/currencyFormatter';
import i18n from 'src/translation/i18n';

interface IApplyToOldestProps extends RouteComponentProps {
  totalCredit: any;
  totalDebit: any;
  filtervalues: any;
}

class OpenInvoices extends React.Component<
  IApplyToOldestProps,
  {
    isDisabldBtn: boolean;
    showdisabledPopup: boolean;
    isDisabledBtn: boolean;
    showdisabledoldestPopup: boolean;
    showPay: boolean;
    showNoCreditPopup: boolean;
    showNoDebitPopup: boolean;
  }
> {
  // x :IOpenInvoicesProps
  // y: IOpenInvoicesState
  //   public clickHandler() {
  // return (<div>

  // <InvoiceRoute match={this.props.match} />
  // </div>);

  // }
  constructor(props: any) {
    super(props);
    this.state = {
      isDisabldBtn: false,
      isDisabledBtn: false,
      showdisabledPopup: false,
      showdisabledoldestPopup: false,
      showPay: false,
      showNoCreditPopup: false,
      showNoDebitPopup: false
    };
  }
  public clickclose = () => {
    this.setState({ showNoCreditPopup: false, showNoDebitPopup: false });
    if (this.state.isDisabldBtn) {
      this.setState({ showdisabledPopup: false });
      this.setState({ showdisabledoldestPopup: false });
      return;
    }
  };
  public Handlerclick = () => {
    if (this.state.isDisabledBtn) {
      this.setState({ showdisabledoldestPopup: true });
      return;
    }
    if (this.props.totalCredit === 0) {
      this.setState({ showNoCreditPopup: true });
      return;
    } else if (this.props.totalDebit === 0) {
      this.setState({ showNoDebitPopup: true });
      return;
    } else if (this.props.totalCredit === 0 && this.props.totalDebit === 0) {
      this.setState({ showNoDebitPopup: true });
      return;
    }
    this.props.history.push('/invoices/applyOldest');
  };

  public clickHandler = () => {
    // goToApplyToOriginal();
    if (this.state.isDisabldBtn) {
      this.setState({ showdisabledPopup: true });
      return;
    }
    if (this.props.totalCredit === 0) {
      this.setState({ showNoCreditPopup: true });
      return;
    } else if (this.props.totalDebit === 0) {
      this.setState({ showNoDebitPopup: true });
      return;
    } else if (this.props.totalCredit === 0 && this.props.totalDebit === 0) {
      this.setState({ showNoDebitPopup: true });
      return;
    }
    // this.props.getOriginalInvoices();
    this.props.history.push('/invoices/applyOriginal');
  };
  public checkboxcall = (selected: any) => {
    // this.setState({
    //  isDisabldBtn: !true
    // })
    // this.setState(prevState => ({
    //   isDisabldBtn: !prevState.isDisabldBtn,
    //   isDisabledBtn: !prevState.isDisabledBtn
    // }));
    if (selected && selected.length > 0) {
      this.setState({
        isDisabldBtn: true,
        isDisabledBtn: true
      });
    } else {
      this.setState({
        isDisabldBtn: false,
        isDisabledBtn: false
      });
    }
  };

  public componentDidMount = () => {
    if (window.innerWidth > 1023) {
      this.setState({
        showPay: true
      });
    }
  };

  public render() {
    return (
      <>
        <div className="OpenInvoices-Credits">
          {window.innerWidth <= 1023 && (
            <div className="trigger-wrapper">
              <div className="invoice-filters-trigger marbottom0">
                <span>Pay</span>
                <div className="arrow-symbol">
                  <img
                    src={
                      this.state.showPay === true ? DownArrowIcon : RightArrow
                    }
                    onClick={() =>
                      this.setState({ showPay: !this.state.showPay })
                    }
                  />
                </div>
              </div>
            </div>
          )}

          <div className="total-credits creditBtnSection">
            {this.state.showPay && (
              <div className="invoice-details">
                {window.innerWidth <= 1023 && (
                  <div className="invoice-verbiage-block">
                    {i18n.t(
                      'invoices.totalsbelowDonotincludePENDINGtransactions'
                    )}
                  </div>
                )}
                {window.innerWidth > 1023 && (
                  <div className="invoice-verbiage">
                    {i18n.t(
                      'invoices.totalsbelowDonotincludePENDINGtransactions'
                    )}
                  </div>
                )}
                <div className="float-left">
                  <span className="open-invoices">
                    {i18n.t('invoices.openInvoices')}:{' '}
                  </span>
                  <span className="credit-debit-values">
                    {/* <b>{'$' + this.props.totalDebit.toFixed(2)}</b> */}
                    <b>{currencyFormatter(this.props.totalDebit)}</b>
                  </span>
                  <span className="margin">|</span>
                </div>

                <div className="float-left">
                  <span className="open-invoices">
                    {i18n.t('invoices.openCredits')}:{' '}
                  </span>
                  <span className="credit-debit-values">
                    {/* <b>{'$' + this.props.totalCredit.toFixed(2)}</b> */}
                    <b>{currencyFormatter(this.props.totalCredit)}</b>
                  </span>
                  <span className="margin">|</span>
                </div>

                <div className="float-left">
                  <span className="open-invoices">
                    {i18n.t('invoices.totalAfterCredits')}:{' '}
                  </span>
                  <span className="credit-debit-values">
                    {/* <b>
                    {'$' +
                      (this.props.totalDebit - this.props.totalCredit).toFixed(
                        2
                      )}
                  </b> */}
                    <b>
                      {currencyFormatter(
                        this.props.totalDebit - this.props.totalCredit
                      )}
                    </b>
                  </span>
                </div>
              </div>
            )}
            {/* <div className="left-side d-flex mobile-btn">
              <button
                className={`btn ${
                  this.state.isDisabldBtn === true ? 'disabled-btn' : ''
                }`}
                onClick={this.clickHandler}
                // disabled={this.state.isDisabldBtn}
                // disabled={this.props.totalCredit === 0 ? true : false}
              >
                Apply Credits to Original 
              </button>
              <button
                className={`btn ${
                  this.state.isDisabledBtn === true ? 'disabled-btn' : ''
                }`}
                onClick={this.Handlerclick}
                // disabled={this.props.totalCredit === 0 ? true : false}
              >
                Apply Credits to Oldest 
              </button>
            </div> */}
            <div className="float-right d-flex">
              <button
                className={`btn ${
                  this.state.isDisabldBtn === true ? 'disabled-btn' : ''
                }`}
                onClick={this.clickHandler}
                disabled={this.props.totalCredit === 0 ? true : false}
              >
                {window.innerWidth > 767
                  ? i18n.t('invoices.applyCreditstoOriginal')
                  : i18n.t('invoices.applytoOriginal')}
              </button>
              <button
                className={`btn ${
                  this.state.isDisabledBtn === true ? 'disabled-btn' : ''
                }`}
                onClick={this.Handlerclick}
                disabled={this.props.totalCredit === 0 ? true : false}
              >
                {window.innerWidth > 767
                  ? i18n.t('invoices.applyCreditstoOldest')
                  : i18n.t('invoices.applytoOldest')}
              </button>
            </div>
          </div>
          {/* <div className="paginator-container-display ">
            <div className="d-flex mg-bottom">
              
            </div>
          </div> */}
          <div>
            <EnhancedTable
              isChecked={this.checkboxcall}
              filtervalues={this.props.filtervalues}
            />
            {/* <DataTable/> */}
          </div>
          {/* <ApplyToOriginal /> */}
          {/* <ApplyToOldest /> */}
          {/* <ApplyCreditMadePayment/> */}
          {/* <SelectCreditTable/> */}
          {this.state.showdisabledPopup ? (
            <div>
              <Modal handleCloseModal={() => console.log('Modal closed')}>
                <div className="apply-original-modal">
                  <div className="d-flex justify-space-bw">
                    <div className="modal-label">
                      <b>
                        {i18n.t('invoices.aboutApplyingtoOriginalInvoices')}
                      </b>
                    </div>
                    <div className="close-icon" onClick={this.clickclose}>
                      <MatrialCloseIcon fontSize="default" />
                    </div>
                  </div>
                  <div className="modal-content">
                    {i18n.t(
                      'invoices.pleaseremovetheselectedinvoicetoproceedwiththisoption'
                    )}
                  </div>

                  <div className="text-align-center">
                    <button className="ok-btn" onClick={this.clickclose}>
                      {i18n.t('invoices.oK')}
                    </button>
                  </div>
                </div>
              </Modal>
            </div>
          ) : (
            ''
          )}
          {this.state.showNoCreditPopup ? (
            <div>
              <Modal handleCloseModal={() => console.log('Modal closed')}>
                <div className="apply-original-modal">
                  <div className="d-flex justify-space-bw">
                    <div className="modal-label">
                      <b>{i18n.t('invoices.noCreditAvailable')}</b>
                    </div>
                    <div className="close-icon" onClick={this.clickclose}>
                      <MatrialCloseIcon fontSize="default" />
                    </div>
                  </div>
                  <div className="modal-content">
                    {i18n.t(
                      'invoices.pleaseusemanualmethodtopayfortheinvoices'
                    )}
                  </div>
                  <div className="text-align-center">
                    <button className="ok-btn" onClick={this.clickclose}>
                      {i18n.t('invoices.oK')}
                    </button>
                  </div>
                </div>
              </Modal>
            </div>
          ) : (
            ''
          )}
          {this.state.showNoDebitPopup ? (
            <div>
              <Modal handleCloseModal={() => console.log('Modal closed')}>
                <div className="apply-original-modal">
                  <div className="d-flex justify-space-bw">
                    <div className="modal-label">
                      <b>{i18n.t('invoices.noDebitAvailable')}</b>
                    </div>
                    <div className="close-icon" onClick={this.clickclose}>
                      <MatrialCloseIcon fontSize="default" />
                    </div>
                  </div>
                  <div className="modal-content">
                    {i18n.t('invoices.youdonotHaveAnyDebitAvailable')}
                  </div>
                  <div className="text-align-center">
                    <button className="ok-btn" onClick={this.clickclose}>
                      {i18n.t('invoices.oK')}
                    </button>
                  </div>
                </div>
              </Modal>
            </div>
          ) : (
            ''
          )}
          {this.state.showdisabledoldestPopup ? (
            <div>
              <Modal handleCloseModal={() => console.log('Modal closed')}>
                <div className="apply-original-modal">
                  <div className="d-flex justify-space-bw">
                    <div className="modal-label">
                      <b> {i18n.t('invoices.aboutApplyingtoOldestInvoices')}</b>
                    </div>
                    <div className="close-icon" onClick={this.clickclose}>
                      <MatrialCloseIcon fontSize="default" />
                    </div>
                  </div>
                  <div className="modal-content">
                    {i18n.t(
                      'invoices.pleaseremovetheselectedinvoicetoproceedwiththisoption'
                    )}
                  </div>

                  <div className="text-align-center">
                    <button className="ok-btn" onClick={this.clickclose}>
                      {i18n.t('invoices.oK')}
                    </button>
                  </div>
                </div>
              </Modal>
            </div>
          ) : (
            ''
          )}
        </div>
      </>
    );
  }
}

export default withRouter(OpenInvoices);
